import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import CofirmModal from './common/ConfirmModal';
import CampaignService from '../service/CampaignService';
import { useSelector } from 'react-redux';

function CampaingsRecords(props) {
    const [show, setshow] = useState(false)
    const [model, setModel] = useState(0);
    const [selectedCampaign, setSelectedCampaign] = useState()
    const [isDeleted, setIsDeleted] = useState(false)
    
    const userDetails = useSelector((data) => data.common)
    let navigate = useNavigate();


    useEffect(() => {
        props?.index == props?.currentopen ? setshow(true) : setshow(false)
    }, [props.currentopen])

    useEffect(() => {
        if (!isDeleted) return
        props.isDeleted(true)
        setIsDeleted(false)
    }, [isDeleted == true])

    const replacePlaceholders = (str, values) => {
        let parts = str?.split(/\[|\]/);
        for (let i = 1; i < parts?.length; i += 2) {
            let placeholder = parts[i];
            if (values.hasOwnProperty("[" + placeholder + "]")) {
                parts[i] = values["[" + placeholder + "]"];
            }
        }
        let replacedStr = parts?.join('');
        replacedStr = replacedStr?.replace(/<\/?h>/g, '');
        return replacedStr;
    }

    const showTempalteShortCode = (template, type) => {
        let values = {
            "[customer_name]": template?.alertTitle?.firstName,
            "[product_name]": "test Product",
            "[location]": template?.alertTitle?.place,
            "[city]": template?.alertTitle?.city,
            "[state]": template?.alertTitle?.state,
            "[country]": template?.alertTitle?.country,
            "[time]": template?.alertMessage?.time,
          };
          let result = replacePlaceholders(type ? template?.alertTitle?.shortNote : template?.alertMessage?.title, values);
          return result
    }

    const showSponseredShortCode = (template, type) => {
        let values = {
          "[customer_name]": template?.alertTitle?.firstName,
          "[product_name]": "Product",
          "[location]": template?.alertTitle?.place,
          "[city]": template?.alertTitle?.city,
          "[state]": template?.alertTitle?.state,
          "[country]": template?.alertTitle?.country,
          "[time]": template?.alertMessage?.time,
        };
        let result = replacePlaceholders(template?.sponsoredBy, values);
        return result
      }

    const handleRedirect = () => {
        // if (props?.campaign?.pageSettings[0]?.page_customization?.isWidgetUrl) {
        //     window.open(props?.campaign.pageSettings[0].page_customization?.url, "_blank");
        // }
    }

    const showImage = (alertSettings) => {
        if(alertSettings.type === "Visitor Alert"){
            if(alertSettings?.uploadedImage?.imgUrl){
             return alertSettings?.uploadedImage?.imgUrl
            } else {
                 if(alertSettings.templatetype === "icon"){
                   return alertSettings?.IconImg
                 } else {
                   return alertSettings?.tempImg
                 }
            }
     } else {
       if (alertSettings?.uploadedImage?.imgUrl) {
         return alertSettings?.uploadedImage?.imgUrl
       } else {
         return alertSettings?.tempImg
       }
     }
      }

      const handleActiveStatus = (index) => {
        props.isUpdateStatus(index)
      }

      const handleCampaignDiv = (showValue) => {
        setshow(!show)
        props.setcurrentopen(props?.index)
      }

    return (
        <>
            <div className="fp-camp-inner-table">
                <table>
                    <tbody>
                        <tr>
                            <td>{props?.index + 1}</td>
                            <td>
                                <div className="camp-title">
                                    {props.campaign?.name || "Coaching Workshop Autowebinar"}
                                </div>
                            </td>
                            <td>{props?.campaign?.alertSettings?.length}</td>
                            <td>{dayjs(props?.campaign?.created_at).format("MMM DD, YYYY")}</td>
                            <td>{dayjs(props?.campaign?.updated_at).format("MMM DD, YYYY")}</td>
                            <td>
                                <div className="fp_cmpn_status" >
                                    <div className="fp-switch-label">
                                        <input type="checkbox" checked={props?.campaign.status} id={props?.campaign.prof_campaign_id} onChange={() => handleActiveStatus(props?.index)}/>
                                        <label htmlFor={props?.campaign.prof_campaign_id}></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="fp-camp-actions">
                                    <ul>
                                        <li>
                                            <Link to={`/createcampaign/${props?.campaign.prof_campaign_id}`} className="fp-edit-camp fp-has-tooltip">
                                                <img src="https://img.flexifunnels.com/flexiproof-assets/edit.png" alt="" />
                                                <div className="fp-tooltip-info">
                                                    Edit
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                            <a className="fp-delete-camp fp-has-tooltip" onClick ={() => setModel(props?.campaign.prof_campaign_id)}>
                                                <img src="https://img.flexifunnels.com/flexiproof-assets/delete.png" alt="" />
                                                <div className="fp-tooltip-info">
                                                    Delete
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>


                    </tbody>
                </table>
            </div>
            {
                show ?
                    <div className="fp-camp-tabular-details fp-campaingRecordOnly">
                        <div className="fp-tab-wrapper">
                            <div className="fp-widget-boxes-wrapper">

                                {props?.campaign?.alertSettings?.map((alertSetting, index) => {
                                    return (
                                        <div key={`alertSetting_${index}`} className={`fp-template-box ${alertSetting?.alert_customization?.class}`}>
                                            <div className="fp-alert-widget-box">
                                                <div key={`alertSetting_${index}`}
                                                    // className={`fp-widget-box animate__animated ${alertSetting?.alert_customization?.widgetAnimation}`}
                                                    className={`fp-widget-box`}
                                                    
                                                >
                                                    <span className='fp-widget-style1' style={{ background: alertSetting?.alert_customization?.color }}></span>
                                                    <span className="fp-widget-styletwo"
                                                        style={{ background: alertSetting?.alert_customization?.color }}></span>


                                                    <div className="fp_widget_box_inner" style={{ background: alertSetting?.alert_customization?.type !== "Visitor Alert" && alertSetting?.alert_customization?.gradientColor && alertSetting?.alert_customization?.gradientColor !=="#222" && alertSetting?.alert_customization?.gradientColor }}>
                                                        <span className="fp-alert-title" onClick={() => handleRedirect()}>
                                                            {alertSetting?.alert_type?.charAt(0).toUpperCase() + alertSetting?.alert_type?.slice(1) + " Activity"}
                                                        </span>
                                                        <span className="fp-widget-icon" onClick={() => handleRedirect()}
                                                            style={{ background: alertSetting?.alert_customization?.color }}>
                                                            <img src={showImage(alertSetting?.alert_customization)} alt="" />
                                                        </span>
                                                        <div className="fp-widget-content" style={{ background: alertSetting?.alert_customization?.type === "Visitor Alert" && alertSetting?.alert_customization?.gradientColor }}>
                                                            <h5 className=''
                                                                style={{
                                                                    color: alertSetting?.alert_customization?.alertTitle.color && alertSetting?.alert_customization?.alertTitle.color !=="#222" && alertSetting?.alert_customization?.alertTitle.color,
                                                                    fontWeight: alertSetting?.alert_customization?.alertTitle?.isBold ? "bold" : "",
                                                                    textDecoration: alertSetting?.alert_customization?.alertTitle?.isUnderLine ? "underline" : "",
                                                                    fontStyle: alertSetting?.alert_customization?.alertTitle?.isItalic ? "italic" : "",
                                                                }} onClick={() => handleRedirect()}> {showTempalteShortCode(alertSetting?.alert_customization, true)}</h5>
                                                            <p className='' style={{
                                                                color: alertSetting?.alert_customization?.alertMessage.color && alertSetting?.alert_customization?.alertMessage.color !=="#222" && alertSetting?.alert_customization?.alertMessage.color,
                                                                fontWeight: alertSetting?.alert_customization?.alertMessage?.isBold ? "bold" : "",
                                                                textDecoration: alertSetting?.alert_customization?.alertMessage?.isUnderLine ? "underline" : "",
                                                                fontStyle: alertSetting?.alert_customization?.alertMessage?.isItalic ? "italic" : "",
                                                            }} onClick={() => handleRedirect()}>
                                                                {showTempalteShortCode(alertSetting?.alert_customization, false)}
                                                            </p>
                                                            <div className="fp-widget-info" onClick={() => handleRedirect()}>
                                                               { !alertSetting?.alert_customization?.showTime && <span style={{
                                                                   color: alertSetting?.alert_customization?.alertMessage?.color && alertSetting?.alert_customization?.alertMessage?.color !=="#222" && alertSetting?.alert_customization?.alertMessage?.color
                                                                }}>
                                                                    {alertSetting?.alert_customization?.alertMessage?.time}
                                                                </span>}
                                                                {!alertSetting?.alert_customization.isBranding && <>
                                                                    <svg width="18px" height="18px" version="1.1" x="0" y="0" viewBox="0 0 66 66"><g><path d="M25.97 4.02c0-1.67-1.36-3.02-3.03-3.02s-3.02 1.35-3.02 3.02v12.69h6.05zM46.09 4.02c0-1.67-1.36-3.02-3.03-3.02s-3.02 1.35-3.02 3.02v12.69h6.05zM50.87 18.71H15.13c-1.67 0-3.02 1.35-3.02 3.02s1.35 3.02 3.02 3.02h35.73c1.67 0 3.02-1.35 3.02-3.02a3.002 3.002 0 0 0-3.01-3.02zM30.76 64.92c.74.05 1.49.08 2.24.08s1.5-.03 2.24-.08v-9.85h-4.47v9.85zM28.46 50.88h9.09v2.19h-9.09zM17.15 39.94l8.94 8.94h13.82l8.95-8.94V26.76H17.15zM34.1 29.83v7.52h3.8l-6.01 8.46v-7.52h-3.8z" opacity="1"/></g></svg>
                                                                    <img src="https://img.flexifunnels.com/flexiproof-assets/fav.svg" alt="" />

                                                                    <span style={{
                                                                         color: alertSetting?.alert_customization?.alertMessage?.color && alertSetting?.alert_customization?.alertMessage?.color !=="#222" && alertSetting?.alert_customization?.alertMessage?.color
                                                                    }}>
                                                                        {showSponseredShortCode(alertSetting?.alert_customization)}
                                                                    </span>
                                                                </>}
                                                            </div>
                                                            {alertSetting?.alert_customization?.socialMediaUrls && alertSetting?.alert_customization?.isFollowSocailMedia && (
                                                                <div className="fp-widget-social">
                                                                    {alertSetting?.alert_customization?.socialMediaUrls["Facebook"]
                                                                        .length > 0 && (
                                                                            <a href={alertSetting?.alert_customization?.socialMediaUrls["Facebook"]
                                                                            } target='_blank' className='fpFacebook'>
                                                                                <svg width="15px" height="15px" version="1.1" x="0" y="0" viewBox="0 0 100 100"><g><path d="M40.4 55.2h-9.9c-1.6 0-2.1-.6-2.1-2.1V41c0-1.6.6-2.1 2.1-2.1h9.9v-8.8c0-4 .7-7.8 2.7-11.3 2.1-3.6 5.1-6 8.9-7.4 2.5-.9 5-1.3 7.7-1.3h9.8c1.4 0 2 .6 2 2v11.4c0 1.4-.6 2-2 2-2.7 0-5.4 0-8.1.1-2.7 0-4.1 1.3-4.1 4.1-.1 3 0 5.9 0 9h11.6c1.6 0 2.2.6 2.2 2.2V53c0 1.6-.5 2.1-2.2 2.1H57.3v32.6c0 1.7-.5 2.3-2.3 2.3H42.5c-1.5 0-2.1-.6-2.1-2.1V55.2z" fill="#fff" opacity="1" data-original="#fff"/></g></svg>
                                                                            </a>
                                                                        )}
                                                                    {alertSetting?.alert_customization?.socialMediaUrls && alertSetting?.alert_customization?.socialMediaUrls["Instagram"]
                                                                        .length > 0 && (
                                                                            <a href={alertSetting?.alert_customization?.socialMediaUrls["Instagram"]} target='_blank' className='fpInsta'>
                                                                                <svg width="12" height="12" version="1.1" x="0" y="0" viewBox="0 0 511 511.9"><g><path d="M510.95 150.5c-1.2-27.2-5.598-45.898-11.9-62.102-6.5-17.199-16.5-32.597-29.6-45.398-12.802-13-28.302-23.102-45.302-29.5-16.296-6.3-34.898-10.7-62.097-11.898C334.648.3 325.949 0 256.449 0s-78.199.3-105.5 1.5c-27.199 1.2-45.898 5.602-62.097 11.898-17.204 6.5-32.602 16.5-45.403 29.602-13 12.8-23.097 28.3-29.5 45.3-6.3 16.302-10.699 34.9-11.898 62.098C.75 177.801.449 186.5.449 256s.301 78.2 1.5 105.5c1.2 27.2 5.602 45.898 11.903 62.102 6.5 17.199 16.597 32.597 29.597 45.398 12.801 13 28.301 23.102 45.301 29.5 16.3 6.3 34.898 10.7 62.102 11.898 27.296 1.204 36 1.5 105.5 1.5s78.199-.296 105.5-1.5c27.199-1.199 45.898-5.597 62.097-11.898a130.934 130.934 0 0 0 74.903-74.898c6.296-16.301 10.699-34.903 11.898-62.102 1.2-27.3 1.5-36 1.5-105.5s-.102-78.2-1.3-105.5zm-46.098 209c-1.102 25-5.301 38.5-8.801 47.5-8.602 22.3-26.301 40-48.602 48.602-9 3.5-22.597 7.699-47.5 8.796-27 1.204-35.097 1.5-103.398 1.5s-76.5-.296-103.403-1.5c-25-1.097-38.5-5.296-47.5-8.796C94.551 451.5 84.45 445 76.25 436.5c-8.5-8.3-15-18.3-19.102-29.398-3.5-9-7.699-22.602-8.796-47.5-1.204-27-1.5-35.102-1.5-103.403s.296-76.5 1.5-103.398c1.097-25 5.296-38.5 8.796-47.5C61.25 94.199 67.75 84.1 76.352 75.898c8.296-8.5 18.296-15 29.398-19.097 9-3.5 22.602-7.7 47.5-8.801 27-1.2 35.102-1.5 103.398-1.5 68.403 0 76.5.3 103.403 1.5 25 1.102 38.5 5.3 47.5 8.8 11.097 4.098 21.199 10.598 29.398 19.098 8.5 8.301 15 18.301 19.102 29.403 3.5 9 7.699 22.597 8.8 47.5 1.2 27 1.5 35.097 1.5 103.398s-.3 76.301-1.5 103.301zm0 0" fill="#fff" opacity="1" data-original="#fff"/><path d="M256.45 124.5c-72.598 0-131.5 58.898-131.5 131.5s58.902 131.5 131.5 131.5c72.6 0 131.5-58.898 131.5-131.5s-58.9-131.5-131.5-131.5zm0 216.8c-47.098 0-85.302-38.198-85.302-85.3s38.204-85.3 85.301-85.3c47.102 0 85.301 38.198 85.301 85.3s-38.2 85.3-85.3 85.3zM423.852 119.3c0 16.954-13.747 30.7-30.704 30.7-16.953 0-30.699-13.746-30.699-30.7 0-16.956 13.746-30.698 30.7-30.698 16.956 0 30.703 13.742 30.703 30.699zm0 0" fill="#fff" opacity="1" data-original="#fff"/></g></svg>
                                                                            </a>
                                                                        )}
                                                                    {alertSetting?.alert_customization?.socialMediaUrls && alertSetting?.alert_customization?.socialMediaUrls["Twitter"]
                                                                        .length > 0 && (
                                                                            <a href={alertSetting?.alert_customization?.socialMediaUrls["Twitter"]} target='_blank' className='fpTwitter'>
                                                                                <svg version="1.1" width="11px" height="11px"  x="0" y="0" viewBox="0 0 1226.37 1226.37"><g><path d="M727.348 519.284 1174.075 0h-105.86L680.322 450.887 370.513 0H13.185l468.492 681.821L13.185 1226.37h105.866l409.625-476.152 327.181 476.152h357.328L727.322 519.284zM582.35 687.828l-47.468-67.894-377.686-540.24H319.8l304.797 435.991 47.468 67.894 396.2 566.721H905.661L582.35 687.854z" opacity="1"/></g></svg>
                                                                            </a>
                                                                        )}
                                                                    {alertSetting?.alert_customization?.socialMediaUrls && alertSetting?.alert_customization?.socialMediaUrls["Pinterest"]
                                                                        .length > 0 && (
                                                                            <a href={alertSetting?.alert_customization?.socialMediaUrls["Pinterest"]} target='_blank' className='fpPint'>
                                                                                <svg width="12px" height="12px" version="1.1" x="0" y="0" viewBox="0 0 511.977 511.977"><g><path d="M262.948 0C122.628 0 48.004 89.92 48.004 187.968c0 45.472 25.408 102.176 66.08 120.16 6.176 2.784 9.536 1.6 10.912-4.128 1.216-4.352 6.56-25.312 9.152-35.2.8-3.168.384-5.92-2.176-8.896-13.504-15.616-24.224-44.064-24.224-70.752 0-68.384 54.368-134.784 146.88-134.784 80 0 135.968 51.968 135.968 126.304 0 84-44.448 142.112-102.208 142.112-31.968 0-55.776-25.088-48.224-56.128 9.12-36.96 27.008-76.704 27.008-103.36 0-23.904-13.504-43.68-41.088-43.68-32.544 0-58.944 32.224-58.944 75.488 0 27.488 9.728 46.048 9.728 46.048S144.676 371.2 138.692 395.488c-10.112 41.12 1.376 107.712 2.368 113.44.608 3.168 4.16 4.16 6.144 1.568 3.168-4.16 42.08-59.68 52.992-99.808 3.968-14.624 20.256-73.92 20.256-73.92 10.72 19.36 41.664 35.584 74.624 35.584 98.048 0 168.896-86.176 168.896-193.12C463.62 76.704 375.876 0 262.948 0z" fill="#fff" opacity="1" data-original="#fff"/></g></svg>
                                                                            </a>
                                                                        )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>                                                    
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                                }
                               
                            </div>
                        </div>
                    </div>
                    : <></>
            }

            <div onClick={() => handleCampaignDiv(show)
            } className="fp-camp-tabular-foot">
                {props?.campaign?.alertSettings?.length < 3 && 
                <span className={"fp-add-alert-btn ".concat(show ? "show" : "")} onClick={() => navigate(`/createcampaign/${props?.campaign.prof_campaign_id}`)}><span>+</span>Add More Alerts</span>
                }
                <span className={"fp-toggle-arrow ".concat(show ? "show" : "")}>
                    <img src="images/toggle-arrow.svg" alt="" />
                </span>
            </div>
            <CofirmModal
            title={props?.campaign.prof_campaign_id}
            shownPopup={model}
            closePopup={() => {
                setModel(false)
            }}
            type={"Campaign"}
                removeAction={() => {
                    CampaignService.deleteCampaign({ user_id: userDetails.user.id, id: model, type: "campaign", token: userDetails?.token }).then((resp => {
                        if (resp.data.success) {
                            setModel(false)
                            setIsDeleted(true)
                        }
                    }))
                }}
            />
        </>
    )
}

export default CampaingsRecords;